// extracted by mini-css-extract-plugin
export var contrastLow = "_redotech-redo-web-lib-link-contrast-low";
export var externalLink = "_redotech-redo-web-lib-link-external-link";
export var externalLinkIcon = "_redotech-redo-web-lib-link-external-link-icon";
export var link = "_redotech-redo-web-lib-link-link";
export var linkLabel = "_redotech-redo-web-lib-link-link-label";